"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var combineVerifications_1 = require("./combineVerifications");
exports.mustPassOneOf = function (allCourses) {
    var validations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        validations[_i - 1] = arguments[_i];
    }
    return function (courses) {
        if (courses === void 0) { courses = allCourses; }
        var results = validations.map(function (v) { return v(courses); });
        var firstPassingResult = results.find(function (r) { return r.pass; });
        if (firstPassingResult) {
            return firstPassingResult;
        }
        return combineVerifications_1.default(results, courses);
    };
};
//# sourceMappingURL=mustPassOneOfValidations.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/utils/mustPassOneOfValidations.js
// module id = 130
// module chunks = 22